
import AppBrowse from "@/components/browse/Browse.vue";
import Project from "@/models/base/project";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { UserConfigService } from "../../services/user-config-service";
import { DossierService } from "@/services/dossier-service";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import {DossierConfigService} from "@/services";
import {ProjectService} from "@/services/project-service";

export default Vue.extend({
	data() {
		return {
			selectedItems: [] as Project[],
		};
	},
	props: {
		browseId: Number,
	},
	computed: {
		dataSource(): IBrowseDataSource<Project> {
			let elem = this;
			return {
				getFullElement: (el:Project)=>ProjectService.get(el.ID),
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: ProjectService.getProject.bind(ProjectService),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return ProjectService.getTotals(view);
				},
				edit(project: Project) {
					elem.$router.push({path: `/projects/edit/${project.ID}`});
				},
				info(project: Project) {
					elem.$router.push({path: `/projects/info/${project.ID}`});
				},
				async delete(project: Project[]) {
					await ProjectService.delete(project);
					return true;
				},
				addRoute: `/projects/new`,
				browseName: "Project",
				modelName: "Project",
				browsePermissions: () => UserConfigService.getPermissionSettings().ProjectPermissions,
				onSocketElementUpdated: (data: any) => new Project(data),
				extraFieldSettings: {
					getExtraFields: ProjectService.getExtraFields.bind(ProjectService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().ProjectNames,
					batchEdit: ProjectService.batchEditExtraField.bind(ProjectService),
					edit: (ProjectService.updateExtraFields as any).bind(ProjectService)
				}
			};
		},
	},
	async mounted() {
		ToolbarService.title = this.$ct("project");
		await DossierService.getUsers();
	},
	components: {
		AppBrowse
	},
	i18nEx: {
		componentPrefix: "components.project"
	},
});
